import {activityPlaces} from '@mep/pae-commons';
import {Empty, Skeleton} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import Office
  from '@/modules/company/containers/CompanyInfoDetailContainer/containers/OfficesPanelContainer/components/Office';
import {useActivityPlaces} from '@/modules/company/hooks/useActivityPlaces';

const {ACTIVITY_PLACE_STATUS} = activityPlaces;

const OfficeList = ({
  proposalId,
  className = 'pt-4',
  filters,
  showEmpty,
  procedureId,
  isCompanyView,
  isProcedureView,
  isTCP,
  ...rest
}) => {
  const {
    data: activityPlaces,
    isLoading
  } = useActivityPlaces(proposalId, procedureId, filters, isCompanyView, isProcedureView);
  
  if (isLoading) return <Skeleton active={false}/>;
  
  if (showEmpty && !activityPlaces?.data?.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
  
  return (
    <div className={classNames('flex flex-col px-1 items-center w-full h-full', className)}>
      <div className="w-full flex flex-col gap-4">
        {(isCompanyView && !isTCP) && <Office
          {...rest}
          address={rest?.company?.address}
          status={ACTIVITY_PLACE_STATUS.ACCEPTED}
          activities={[rest?.company?.mainActivity].concat(rest?.company?.activities)}
        />}
        {activityPlaces?.data?.map((office) => <Office
          key={office?._id}
          id={office?._id}
          {...office}
          {...rest}
        />)}
      </div>
    </div>
  );
};


OfficeList.propTypes = {
  proposalId: PropTypes.string,
  procedureId: PropTypes.string,
  className: PropTypes.string,
  allowRemove: PropTypes.bool,
  isTCP: PropTypes.bool,
  isCompanyView: PropTypes.bool,
  isProcedureView: PropTypes.bool,
  showEmpty: PropTypes.bool,
  filters: PropTypes.any
};


export default memo(OfficeList);
